import { render, staticRenderFns } from "./ReportsDeliverySacBostonPublicResultView.vue?vue&type=template&id=5c6586f7"
import script from "./ReportsDeliverySacBostonPublicResultView.vue?vue&type=script&lang=ts"
export * from "./ReportsDeliverySacBostonPublicResultView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports